function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7141 1H20.3073C21.794 1 23 2.21649 23 3.7172V7.34051C23 8.84009 21.794 10.0577 20.3073 10.0577H16.7141C15.2263 10.0577 14.0203 8.84009 14.0203 7.34051V3.7172C14.0203 2.21649 15.2263 1 16.7141 1Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.69381 1H7.28594C8.77374 1 9.97975 2.21649 9.97975 3.7172V7.34051C9.97975 8.84009 8.77374 10.0577 7.28594 10.0577H3.69381C2.20602 10.0577 1 8.84009 1 7.34051V3.7172C1 2.21649 2.20602 1 3.69381 1Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.69381 13.9424H7.28594C8.77374 13.9424 9.97975 15.1589 9.97975 16.6607V20.2829C9.97975 21.7836 8.77374 23.0001 7.28594 23.0001H3.69381C2.20602 23.0001 1 21.7836 1 20.2829V16.6607C1 15.1589 2.20602 13.9424 3.69381 13.9424Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.7141 13.9424H20.3073C21.794 13.9424 23 15.1589 23 16.6607V20.2829C23 21.7836 21.794 23.0001 20.3073 23.0001H16.7141C15.2263 23.0001 14.0203 21.7836 14.0203 20.2829V16.6607C14.0203 15.1589 15.2263 13.9424 16.7141 13.9424Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/Categories.541db881.svg";
export { ForwardRef as ReactComponent };